export default __webpack_public_path__ + "static/media/muchowka.6f2e8e46.svg";